import { Serializers, SerializerValue } from "@megaron/serializers";

export const productAvailabilityFiltersSerializer = Serializers.object({
  page: Serializers.integer,
  regions: Serializers.string.array().asJsonString(),
  searchTerm: Serializers.string,
}).partial();

export type ProductAvailabilityFilters = SerializerValue<typeof productAvailabilityFiltersSerializer>;
